import * as firebase from 'firebase';

export const LOGIN_START = 'login_start';
export const LOGIN_SUCCESS = 'login_success';
export const LOGIN_FAIL = 'login_fail';
export const LOGOUT = 'perform_logout';

export function login(email, password, callback) {

    return dispatch => {
        dispatch({ type: LOGIN_START });

        firebase.auth().signInWithEmailAndPassword(email, password)
            .then(() => {
                dispatch({ 
                    type: LOGIN_SUCCESS
                });
                if (callback) {
                    callback(true);
                }
            }).catch((error) => {
                dispatch({
                    type: LOGIN_FAIL
                });
                if (callback) {
                    callback(false, error.message);
                }
            });
    };
}

export function logout() {

    return dispatch => {

        firebase.auth().signOut().then(function () {
            dispatch({ type: LOGOUT });
        }).catch(function (error) {

        });
    }
}

export function changePassword({ password, newPassword }, callback) {

    const user = firebase.auth().currentUser;

    return (dispatch) => {
        if (user) {
            performChangePassword(user, dispatch, password, newPassword, callback);
        } else {
            handleChangePasswordFail(dispatch, 'Errors', callback);
        }
    };
}

function performChangePassword(user, dispatch, password, newPassword, callback) {

    user.updatePassword(newPassword)
        .then(() => {
            if (callback) {
                callback();
            }
        })
        .catch(error => {
            console.log(error);
            const { code, message } = error;

            if (code === 'auth/requires-recent-login') {
                reAuthenticate(user, dispatch, password, newPassword, callback);
            } else {
                handleChangePasswordFail(dispatch, message, callback);
            }
        });
}

function handleChangePasswordFail(dispatch, message, callback) {
    if (callback) {
        callback(message);
    }
}

export function reAuthenticate(user, dispatch, password, newPassword, callback) {
    const cred = firebase.auth.EmailAuthProvider.credential(user.email, password);

    user.reauthenticateWithCredential(cred)
        .then(() => {
            // process change password again
            performChangePassword(user, dispatch, password, newPassword, callback)
        })
        .catch(error => {
            console.log(error);
            handleChangePasswordFail(dispatch, error.message, callback);
        });
}


// WEBPACK FOOTER //
// ./src/actions/Authentication.js